import React, {useCallback, useEffect, useState} from 'react';
import {Provider} from 'react-redux';
import {setCategories} from '../../data/actions/categories';
import {setQuery} from '../../data/actions/query';
import {setString} from '../../data/actions/strings';
import {createNewStore} from '../../data/store';
import QueryBuilder from './QueryBuilder';
import {updatePreview} from '../../data/actions/preview';
import {setShowPreview} from '../../data/actions/ui';

function QueryBuilderWrapper(props) {
    const {
            value: initialValue,
            categories = [],
            emptyPrompt,
            prompt,
            previewLinkText,
            showPreview = true,
            onShowPreview,
            inputField,
            onChange,
            publicAccess,
        } = props,
        [store] = useState(createNewStore),
        [initialized, setInitialized] = useState(false),
        {dispatch, getState} = store;

    // Categories
    useEffect(() => {
        if (categories) dispatch(setCategories(categories));
    }, [categories]);

    // Query
    useEffect(() => {
        if (initialValue) dispatch(setQuery(initialValue));
    }, []);

    // Enable/disable preview
    useEffect(() => {
        dispatch(setShowPreview(showPreview));
    }, [showPreview]);

    // Strings
    useEffect(() => {
        dispatch([setString('emptyPrompt', emptyPrompt), setString('prompt', prompt), setString('previewLinkText', previewLinkText)]);
    }, [emptyPrompt, prompt, previewLinkText]);

    const handleChange = useCallback(
        newValue => {
            if (onChange) onChange(newValue);
            if (inputField) inputField.value = JSON.stringify(newValue);
        },
        [onChange]
    );

    useEffect(() => {
        if (publicAccess) {
            publicAccess.setPreviews = function (total, perFilter) {
                dispatch(updatePreview(total, perFilter));
            };
            publicAccess.getValue = function () {
                return getState().query;
            };
            return () => {
                delete publicAccess.setPreviews;
                delete publicAccess.getValue;
            };
        }
    }, [publicAccess]);

    useEffect(() => {
        setInitialized(true);
    }, []);

    if (!initialized) return null;

    return (
        <Provider store={store}>
            <QueryBuilder onChange={handleChange} onShowPreview={onShowPreview} />
        </Provider>
    );
}

export default QueryBuilderWrapper;
